import Image from '@base/FutureImage';
import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';

const Wrapper = styled.div`
  display: flex;
  height: calc(100vh - 80px);
  width: calc(100vw - 32px);
  flex-direction: column;
  gap: ${Spacings.SPACING_4B};
  align-items: center;
  justify-content: center;
`;

const MiddleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_2B};
  align-items: center;
`;

const StyAquillaButton = styled(AquillaButton)`
  height: ${Spacings.SPACING_12B};
  border-radius: ${Spacings.SPACING_2B};
  min-width: 156px;
  max-width: 156px;
  font-size: ${Fonts.H6};
  font-weight: ${Fonts.HEAVY};
`;

const PaymentProcessingState = ({
  title,
  subTitle,
  icon,
  iconAlt,
  ctaText = null,
  handleCta = () => {}
}) => {
  return (
    <Wrapper>
      <Image src={icon} width={120} height={120} alt={iconAlt} />
      <MiddleWrapper>
        <Typography variant="h3">{title}</Typography>
        <Typography variant="p3" color="var(--color-i-gray-13)">
          {subTitle}
        </Typography>
      </MiddleWrapper>
      {ctaText && (
        <StyAquillaButton variant="primary" onClick={handleCta}>
          Okey
        </StyAquillaButton>
      )}
    </Wrapper>
  );
};

export default PaymentProcessingState;
